import { QueryFn } from '@percent/grants-nomination-form/hooks';
import { config } from '@percent/grants-nomination-form/config/config';
import { GetRegistriesParams, GetRegistriesResponse } from './registries.types';

export const getRegistriesAction: QueryFn<[string, GetRegistriesParams], GetRegistriesResponse> = async (
  client,
  [_, args],
) => {
  const response = await client.get(`v1/registries`, { params: args, headers: { Authorization: config.keys.pk } });

  return response.data;
};
